import { selector } from '@/lib/selectors';

// Leaf selectors: nothing from domain/ is imported here at runtime, so any
// selector module can depend on this one without an import cycle.
const documents = (state) => state.documents;

// Which company the company-scoped data held in the store was loaded for. NOT the current
// company (@/domain/router currentCompanyIdSelector): it keeps the last company on pages that
// name none and lags a company switch until the sign-in completes. Read by the entering
// check and by the few places listed in DA-20064's design that rely on "the last company".
export const loadedDataCompanyIdSelector = selector(documents, (d) => d.companyId);
